import { render, staticRenderFns } from "./USDCard.vue?vue&type=template&id=4e64ff16&"
import script from "./USDCard.vue?vue&type=script&lang=js&"
export * from "./USDCard.vue?vue&type=script&lang=js&"
import style0 from "./USDCard.vue?vue&type=style&index=0&id=4e64ff16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports